import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { GradientTypography } from 'src/components/gradients/GradientTypography';
import {
  WizardElementProps,
  withoutWizardProps,
} from 'src/components/wizard/Wizard';
import { CheckInStore } from './useCheckInDialog';

export const UnregisteredDialog = withoutWizardProps(
  ({ go }: WizardElementProps<CheckInStore>) => {
    return (
      <>
        <DialogTitle>
          {
            <GradientTypography
              gradientColor="primary.vertical"
              variant="h4"
              sx={{ textTransform: 'uppercase' }}
            >
              {`You've Unregistered`}
            </GradientTypography>
          }
        </DialogTitle>
        <DialogContent sx={{ backgroundImage: 'none' }}>
          <Typography variant="h6">You left the tournament :(</Typography>
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: 'center', pb: 0, px: 0, width: '100%' }}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              return go(undefined);
            }}
            sx={{ flex: 1, mt: 4 }}
          >
            Close
          </Button>
        </DialogActions>
      </>
    );
  },
);
